document.addEventListener(
	'DOMContentLoaded',
	function () {
		const blockElementIdPrefix = `growthstack-personalization-block`;

		const personalizationBlockElements = document.querySelectorAll(
			`[id^="${ blockElementIdPrefix }"]`
		);

		if ( personalizationBlockElements.length > 0 ) {
			growthstackPersonalizations(
				personalizationBlockElements,
				blockElementIdPrefix
			);
		}
	},
	false
);

const growthstackPersonalizations = async (
	personalizationBlockElements,
	blockElementIdPrefix
) => {
	const settings = {
		getActiveEndpoint: window.GROWTHSTACK_PERSONALIZATION.endpoint ?? null,
	};

	/**
	 * Gets the element block ID of an element.
	 *
	 * @param {string} _blockElementIdPrefix The block element ID prefix.
	 * @return {Function} The function that gets an element block ID.
	 */
	const getElementBlockId = ( _blockElementIdPrefix ) => {
		return ( element ) =>
			element.id.replace( `${ _blockElementIdPrefix }-`, '' );
	};

	// personalizationBlockElement.id.replace(
	// 	`${ _blockElementIdPrefix }-`,
	// 	''
	// );

	/**
	 * Gets the value of a cookie.
	 *
	 * @param {string} name The name of the cookie.
	 * @return {*} The value of the cookie.
	 */
	const getCookie = ( name ) => {
		return decodeURIComponent( document.cookie )
			.split( '; ' )
			.filter( ( cookie ) => cookie.indexOf( `${ name }=` ) === 0 )
			.map( ( cookie ) => cookie.substring( name.length + 1 ) );
	};

	/**
	 * Sets a session cookie.
	 *
	 * @param {string} name  The name of the cookie.
	 * @param {string} value The value of the cookie.
	 */
	const setSessionCookie = ( name, value ) => {
		document.cookie = name + '=' + value;
	};

	/**
	 * Checks whether a specific cookie is set.
	 *
	 * @param {string} name The name of the cookie.
	 * @return {boolean} True if the cookie is set, false otherwise.
	 */
	const hasCookie = ( name ) => {
		// const allCookies = decodeURIComponent(document.cookie).split('; ');
		const matchCookies = decodeURIComponent( document.cookie )
			.split( '; ' )
			.filter( ( cookie ) => cookie.indexOf( `${ name }=` ) === 0 );
		return matchCookies.length > 0;
	};

	/**
	 * Get the user data.
	 *
	 * Data parameters:
	 * - user data
	 * - language
	 * - current date
	 * - query parameters
	 * - new user or old user
	 *
	 * @return {Object} User data.
	 */
	const getUserData = () => {
		const queryParams = new URLSearchParams( window.location.search );

		return {
			userAgent: window.navigator.userAgent || '',
			language: window.navigator.language || '',
			date: new Date().toJSON(),
			queryParams: Object.fromEntries( queryParams.entries() ),
			newUser: isNewUser,
			lianaSegments: ! lianaSegments
				? []
				: lianaSegments.filter( ( s ) => s ),
		};
	};

	/**
	 * Gets the personalization blocks in the whole page.
	 *
	 * @param {Object} _personalizationBlockElements The personalization blocks on the page.
	 * @param {string} _blockElementIdPrefix         The block element ID prefix.
	 * @return {Object} The list of personalization blocks in the page.
	 */
	const getPersonalizationBlocks = (
		_personalizationBlockElements,
		_blockElementIdPrefix
	) => {
		const personalizationBlocks = {};

		_personalizationBlockElements.forEach(
			( personalizationBlockElement ) => {
				const blockId = personalizationBlockElement.id.replace(
					`${ _blockElementIdPrefix }-`,
					''
				);

				const blockObjectName =
					window[ `GROWTHSTACK_PERSONALIZATIONS_${ blockId }` ];

				if ( typeof blockObjectName !== 'undefined' ) {
					personalizationBlocks[ blockObjectName.blockId ] =
						blockObjectName;
				}
			}
		);

		return personalizationBlocks;
	};

	/**
	 * Fetches the active post personalizations.
	 *
	 * @param {Array} postIds  Post IDs to query for active personalizations.
	 * @param {Array} userData The user data used to pick the active personalizations.
	 * @return {Object} The list of active personalizations.
	 */
	const fetchActivePostPersonalizations = async ( postIds, userData ) => {
		try {
			const responseData = await Promise.allSettled(
				postIds.map( ( postId ) =>
					fetch( `${ settings.getActiveEndpoint }${ postId }`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify( userData ),
					} ).then( ( response ) => response.json() )
				)
			);
			return responseData;
		} catch ( error ) {
			console.log( error );
		}
	};

	/**
	 * Replaces the default block content with the active personalization content.
	 *
	 * @param {Array}  personalizationBlocks  The list of personalization blocks.
	 * @param {Array}  activePersonalizations The active personalizations.
	 * @param {string} _blockElementIdPrefix  The block element ID prefix.
	 */
	const replacePersonalizationsContent = (
		personalizationBlocks,
		activePersonalizations,
		_blockElementIdPrefix
	) => {
		Object.entries( personalizationBlocks ).forEach(
			( [ blockId, blockValue ] ) => {
				if (
					! activePersonalizations.hasOwnProperty( blockId ) ||
					! activePersonalizations[ blockId ]
				) {
					return;
				}

				const activeVariantIndex =
					blockValue.personalizations.findIndex(
						( blockPersonalization ) =>
							blockPersonalization.id ===
							activePersonalizations[ blockId ]
					);

				const blockElementId = `${ _blockElementIdPrefix }-${ blockId }`;
				const blockElementIdEnd = `${ _blockElementIdPrefix }-${ blockId }-end`;

				const personalizationBlockElement =
					document.getElementById( blockElementId );
				const personalizationBlockEndElement =
					document.getElementById( blockElementIdEnd );
				const defaultContentElements = [];
				let nextSibling =
					personalizationBlockElement.nextElementSibling;

				while (
					nextSibling !== null &&
					nextSibling.id !== blockElementIdEnd
				) {
					defaultContentElements.push( nextSibling );
					nextSibling = nextSibling.nextElementSibling;
				}

				defaultContentElements.map( ( element ) => element.remove() );

				personalizationBlockElement.insertAdjacentHTML(
					'afterend',
					blockValue.personalizations[ activeVariantIndex ].content
				);
			}
		);
	};

	const isNewUser = ! hasCookie( 'growthstack-personalization' );
	const lianaSegments = hasCookie( 'liana_s' )
		? getCookie( 'liana_s' ).reduce(
			( acc, s ) => [ ...acc, ...s.split( ',' ) ]
		, [] )
		: [];

	if ( isNewUser ) {
		setSessionCookie( 'growthstack-personalization', true );
	}

	const personalizationBlocks = getPersonalizationBlocks(
		personalizationBlockElements,
		blockElementIdPrefix
	);

	// const blockPostIds = [
	// 	...new Set(
	// 		Object.values( personalizationBlocks ).map(
	// 			( { postId } ) => postId
	// 		)
	// 	),
	// ];

	const activePersonalizationsResponses =
		await fetchActivePostPersonalizations(
			[
				...new Set(
					Object.values( personalizationBlocks ).map(
						( { postId } ) => postId
					)
				),
			],
			getUserData()
		);

	const activePersonalizations = activePersonalizationsResponses.reduce(
		( previous, current ) => {
			return { ...previous, ...current.value.personalizations };
		},
		{}
	);

	replacePersonalizationsContent(
		personalizationBlocks,
		activePersonalizations,
		blockElementIdPrefix
	);

	document
		.querySelectorAll( '.growthstack-personalization-block' )
		.forEach( ( el ) => el.remove() );
	document
		.querySelectorAll( '.growthstack-personalization-block-end' )
		.forEach( ( el ) => el.remove() );
};
